import { useContext, useState } from "react";

import { MaskedInput } from "~/components/TextInput";
import type { OwnIndexProtocol } from "~/modules/aerobicCapabilities/schema";
import { studentEvaluationDemoContext } from "~/pages/authenticated/personalTrainer/studentEvaluationDemo";

export const Polar: React.FC = () => {
	const { data } = useContext(studentEvaluationDemoContext);
	const [value] = useState<OwnIndexProtocol>({
		maxVO2Consumption: data?.ownIndex?.maxVO2Consumption ?? 0,
	});

	return (
		<div className="flex gap-3">
			<MaskedInput
				mask="float"
				inputMode="numeric"
				value={value?.maxVO2Consumption}
				label="Consumo Máximo de VO2"
				placeholder="0"
				readOnly
				onChange={() => undefined}
			/>
		</div>
	);
};
